module.exports = __webpack_public_path__ + "static/assets/895f39649fa47bec302685d0b9f786e3.otf";